import { useNuxtApp, useRequestEvent } from "#imports";
import { getExperimentProvider } from "../config.js";
import { getRequestExperiments } from "../server/getRequestExperiments.js";
import { getDefaultExperiments } from "../utils.js";
export const EXPOSURE_HOOK = "experiments:exposure";
let exposedKeysThisPageView = /* @__PURE__ */ new Set();
export function resetExposureTracking() {
  exposedKeysThisPageView = /* @__PURE__ */ new Set();
}
function resolveProvider(key) {
  const injected = window.__EXPERIMENTS_PROVIDERS__?.[key];
  const compiled = getExperimentProvider(key);
  if (injected !== void 0 && compiled !== void 0 && injected !== compiled) {
    const message = "experiments.provider_mismatch";
    console.error(message, { key, injected, compiled });
  }
  return injected ?? compiled;
}
function trackRead(key, value) {
  if (value === "noVariation") return;
  if (exposedKeysThisPageView.has(key)) return;
  if (resolveProvider(key) !== "amplitude") return;
  exposedKeysThisPageView.add(key);
  const nuxtApp = useNuxtApp();
  void nuxtApp.callHook(EXPOSURE_HOOK, key, value);
}
function createExposureTrackingProxy(experiments) {
  return new Proxy(experiments, {
    get(target, prop, receiver) {
      const value = Reflect.get(target, prop, receiver);
      if (typeof prop === "string" && typeof value === "string") {
        trackRead(prop, value);
      }
      return value;
    }
  });
}
export function getExperimentsSnapshot() {
  const defaultExperiments = getDefaultExperiments();
  if (import.meta.server) {
    const event = useRequestEvent();
    if (event) return getRequestExperiments(event);
    return { ...defaultExperiments };
  }
  return {
    ...defaultExperiments,
    // By using underscore dangles, we follow the same structure as Nuxt.
    // eslint-disable-next-line no-underscore-dangle
    ...window.__EXPERIMENTS__
  };
}
export function useExperiments() {
  const snapshot = getExperimentsSnapshot();
  if (import.meta.client) {
    return createExposureTrackingProxy(snapshot);
  }
  return snapshot;
}
